import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {CityService} from '@services/city.service';
import {SEARCH_CITY_PARAMS} from '@models/empty';
import {AlertService} from '@services/alert.service';
import {AuthenticationService} from '@services/authentification.service';
import {UserSearchCity} from '@models/search';
import {ViewportScroller} from '@angular/common';
import {JoyrideService} from 'ngx-joyride';
import {patchJoyrideScroll} from './joyride-scroll-fix';
import {MatDialog} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import * as $ from 'jquery';

@Injectable({
    providedIn: 'root'
})
export class OnboardingService {

    extChange = new EventEmitter();

    // Tour « sauvegarder une recherche » en cours : force l'affichage du bouton flottant
    // ciblé par les étapes (sinon *ngIf peut le retirer — 0 filtre actif, bouton masqué,
    // chargement — et le tour pointe dans le vide)
    saveTourActive = false;

    constructor(
        private http: HttpClient,
        private cityService: CityService,
        private alertService: AlertService,
        private userService: UserService,
        private scroller: ViewportScroller,
        private readonly joyrideService: JoyrideService,
        private deviceService: DeviceDetectorService,
        private dialog: MatDialog,
        public authenticationService: AuthenticationService) {
        patchJoyrideScroll();
    }

    listen() {
        return this.extChange;
    }

    isOnboardingActivate() {
        // if (!this.deviceService.isDesktop() || !this.authenticationService.isLogin || this.authenticationService.currentUser.pro_plan != 'lybox') {
        if (!this.deviceService.isDesktop()
            || !this.authenticationService.isLogin
            || this.authenticationService.currentUser.user_onboarding.dismiss == true
            || this.authenticationService.currentUser.form == false
            || this.dialog.openDialogs.length > 0 // ne pas lancer l'onboarding si une popup est ouverte
        ) {
            return false;
        }
        return true;
    }

    // Faire une recherche
    startSearch(): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = [
            'searchStep@app/search/result',
            //'searchFilterStep', 'searchStartStep@app/search',
            'searchInfoStep', 'searchResultStep0', 'searchResultMainInfoStep0', 'searchResultInfoStep0', 'searchResultKpiStep0', 'searchResultFilterStep@app/search/result',
            // Étapes filtres dans le bandeau latéral (ouvert par le (next) du bouton Filtrer),
            // plus de navigation vers la page filtres en desktop
            'filtersStep', 'filtersCityStep', 'filtersCitySaveStep', 'filtersTabsStep', 'filtersSquarePriceStep', 'filtersDiffStep', 'filtersRendementStep', 'filtersDPEStep', 'filtersMonthStep', 'filtersValidateStep',
            'searchResult2Step@app/search/result', 'searchSave2Step', 'searchResultOpenStep0@app/search/result'
        ];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.search.status != 'done' && this.authenticationService.currentUser.user_onboarding.search.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.search.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.search.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    if (step.route == 'app/search/result') {
                        this.extChange.emit('search_start');
                    } else if (step.route == 'app/search') {
                        this.extChange.emit('init_search');
                    }
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.endSearch(current_step, steps.length);
                }
            );
        });
        return obs;
    }

    endSearch(current_step, steps_length) {
        this.extChange.emit('search_end');
        // If it's not already done
        if (this.authenticationService.currentUser.user_onboarding.search.status != 'done') {
            if (current_step == steps_length) {
                this.authenticationService.currentUser.user_onboarding.search.status = 'done';
                this.authenticationService.currentUser.user_onboarding.search.date_end = new Date().toISOString();
                this.userService.updateOnboarding(this.authenticationService.currentUser);
                this.showEnd('search');
            }
        }
    }

    // Analyser un favoris
    startFavoris(idList, id): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['introStep@app/favorites/' + idList + '/' + id + '/annonce', 'tabsStep', 'kpisStep', 'widgetsStep', 'inoutTabsStep', 'achatStep@app/favorites/' + idList + '/' + id + '/inout', 'chargeStep', 'revenusStep', 'financementStep', 'simulatorStep', 'impotTabsStep@app/favorites/' + idList + '/' + id + '/impot', 'configImpotStep', 'evolCashFlowImpotStep', 'bilanComptableImpotStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.annonce.status != 'done' && this.authenticationService.currentUser.user_onboarding.annonce.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.annonce.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.annonce.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.endAnnonce(current_step, steps.length);
                }
            );
        });
        return obs;
    }

    // Analyser une annonce
    startAnnonce(id): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['introStep@/app/annonces/' + id + '/annonce', 'tabsStep', 'kpisStep', 'widgetsStep', 'inoutTabsStep', 'achatStep@/app/annonces/' + id + '/inout', 'chargeStep', 'revenusStep', 'financementStep', 'simulatorStep', 'impotTabsStep@/app/annonces/' + id + '/impot', 'configImpotStep', 'evolCashFlowImpotStep', 'bilanComptableImpotStep', 'addtofavoriteStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.annonce.status != 'done' && this.authenticationService.currentUser.user_onboarding.annonce.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.annonce.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.annonce.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    if (current_step == 1) {
                        this.extChange.emit('startAnnonce');
                    }
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.endAnnonce(current_step, steps.length);
                }
            );
        });
        return obs;
    }

    endAnnonce(current_step, steps_length) {
        this.extChange.emit('annonce_end');
        // If it's not already done
        if (this.authenticationService.currentUser.user_onboarding.annonce.status != 'done') {
            if (current_step == steps_length) {
                this.authenticationService.currentUser.user_onboarding.annonce.status = 'done';
                this.authenticationService.currentUser.user_onboarding.annonce.date_end = new Date().toISOString();
                this.userService.updateOnboarding(this.authenticationService.currentUser);
                this.showEnd('annonce');
            }
        }
    }

    showSaveFav() {
        var steps = ['addtofavoriteStep'];

        this.joyrideService.startTour(
            {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    // Trouver les villes rentables
    startVille(): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var currentSearch: UserSearchCity = ({} as UserSearchCity);
        currentSearch.search_city_params = JSON.parse(JSON.stringify(SEARCH_CITY_PARAMS)); // clone : ne pas contaminer la constante partagée
        currentSearch.search_city_params.pop = [130000, 150000];
        this.userService.setCurrentSearchCity(currentSearch);

        var current_step = 0;
        var steps = ['filtersCityStep@app/city/result', 'searchCityResultStep0', 'searchCityResulImgtStep0', 'searchCityFiltersStep@app/city/result', 'cityFilterTabsStep@app/city/result/filters', 'cityFilterCityStep', 'cityFilterLocalisationStep', 'cityFilterSocioStep', 'cityFilterImmoStep', 'cityFilterValidateStep@app/city/result/filters', 'filtersCityResultStep@app/city/result', 'filtersCityResultSaveStep', 'searchSaveCityPopupStep', 'filtersCityListSaveStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.ville.status != 'done' && this.authenticationService.currentUser.user_onboarding.ville.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.ville.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.ville.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    if (step.route == 'app/city/result') {
                        this.extChange.emit('search_city_start');
                    }
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    console.log('complete');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.endVille(current_step, steps.length);
                }
            );
        });
        return obs;
    }

    endVille(current_step, steps_length) {
        this.extChange.emit('search_city_end');
        // If it's not already done
        if (this.authenticationService.currentUser.user_onboarding.ville.status != 'done') {
            if (current_step == steps_length) {
                this.authenticationService.currentUser.user_onboarding.ville.status = 'done';
                this.authenticationService.currentUser.user_onboarding.ville.date_end = new Date().toISOString();
                this.userService.updateOnboarding(this.authenticationService.currentUser);
                this.showEnd('ville');
            }
        }
    }

    // Enregister une recherche
    startSearchSave(): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['searchSaveStep@app/search/result', 'searchSavePopupStep', 'searchSaveListStep'];

        var obs = new Observable((subscriber) => {
            this.saveTourActive = true;
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.search_save.status != 'done' && this.authenticationService.currentUser.user_onboarding.search_save.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.search_save.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.search_save.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    if (step.route == 'app/search/result') {
                        this.extChange.emit('search_start');
                    }
                    if (step.name == 'searchSaveStep' || step.name == 'searchSaveListStep') {
                        setTimeout(function() {
                            this.scroller.scrollToPosition(0);
                        }.bind(this), 1);
                    }
                },
                (error) => {
                    /*handle error*/
                    this.saveTourActive = false;
                    console.log(error);
                },
                () => {
                    /*Tour is finished here, do something*/
                    this.saveTourActive = false;
                    subscriber.next();
                    subscriber.complete();
                    this.extChange.emit('search_end');
                    // If it's not already done
                    if (this.authenticationService.currentUser.user_onboarding.search_save.status != 'done') {
                        if (current_step == steps.length) {
                            this.authenticationService.currentUser.user_onboarding.search_save.status = 'done';
                            this.authenticationService.currentUser.user_onboarding.search_save.date_end = new Date().toISOString();
                        } else {
                            this.authenticationService.currentUser.user_onboarding.search_save.status = 'in_progress';
                            this.authenticationService.currentUser.user_onboarding.search_save.date_start = new Date().toISOString();
                        }
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }
                    this.showEnd();
                }
            );
        });
        return obs;
    }

    // Alert mail
    startAlert(idSearch): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['alertMailStep@app/search/' + idSearch, 'alertCreateStep', 'searchAlertPopupStep', 'valideAlertPopupStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.alert.status != 'done' && this.authenticationService.currentUser.user_onboarding.alert.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.alert.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.alert.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    setTimeout(function() {
                        this.scroller.scrollToPosition(0);
                    }.bind(this), 1);
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    $('#optionDropdown').removeClass('optionDropdownOnboarding');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                }
            );
        });
        return obs;
    }

    endAlert() {
        this.extChange.emit('alert_end');
        if (this.authenticationService.currentUser.user_onboarding.alert.status != 'done') {
            this.authenticationService.currentUser.user_onboarding.alert.status = 'done';
            this.authenticationService.currentUser.user_onboarding.alert.date_end = new Date().toISOString();
            this.userService.updateOnboarding(this.authenticationService.currentUser);
            this.showEnd('alerte');
        }
    }

    // Export PDF
    startPDF(idList, id): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['introStep@app/favorites/' + idList + '/' + id + '/annonce', 'dropdownPDFStep', 'pdfStep@app/favorites/' + idList + '/' + id + '/pdf/lybox', 'pdfAnnonceStep', 'pdfPageStep', 'pdfDownloadStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.pdf.status != 'done' && this.authenticationService.currentUser.user_onboarding.pdf.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.pdf.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.pdf.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    setTimeout(function() {
                        this.scroller.scrollToPosition(0);
                    }.bind(this), 1);
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    $('#optionDropdown').removeClass('optionDropdownOnboarding');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.extChange.emit('pdf_end');
                    // If it's not already done
                    if (this.authenticationService.currentUser.user_onboarding.pdf.status != 'done') {
                        if (current_step == steps.length) {
                            this.authenticationService.currentUser.user_onboarding.pdf.status = 'done';
                            this.authenticationService.currentUser.user_onboarding.pdf.date_end = new Date().toISOString();
                        } else {
                            this.authenticationService.currentUser.user_onboarding.pdf.status = 'in_progress';
                            this.authenticationService.currentUser.user_onboarding.pdf.date_start = new Date().toISOString();
                        }
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }
                    this.showEnd();
                }
            );
        });
        return obs;
    }

    // Start compare
    startCompare(idList): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['compareStep@app/favorites/' + idList, 'introCompareStep@app/favorites/compare', 'addCompareStep', 'comparePriceStep0', 'achatCompareStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.compare.status != 'done' && this.authenticationService.currentUser.user_onboarding.compare.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.compare.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.compare.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    setTimeout(function() {
                        this.scroller.scrollToPosition(0);
                    }.bind(this), 1);
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    $('#optionDropdown').removeClass('optionDropdownOnboarding');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.extChange.emit('pdf_end');
                    // If it's not already done
                    if (this.authenticationService.currentUser.user_onboarding.compare.status != 'done') {
                        if (current_step == steps.length) {
                            this.authenticationService.currentUser.user_onboarding.compare.status = 'done';
                            this.authenticationService.currentUser.user_onboarding.compare.date_end = new Date().toISOString();
                        } else {
                            this.authenticationService.currentUser.user_onboarding.compare.status = 'in_progress';
                            this.authenticationService.currentUser.user_onboarding.compare.date_start = new Date().toISOString();
                        }
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }
                    this.showEnd();
                }
            );
        });
        return obs;
    }

    // Mes favoris
    startFavoriteList(idList): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['introStep@app/favorites/' + idList, 'favListInfoStep0', 'favListKPIStep0', 'favListLastInfoStep0', 'listDropdownStep', 'listColumnStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.favoris_list.status != 'done' && this.authenticationService.currentUser.user_onboarding.favoris_list.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.favoris_list.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.favoris_list.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    setTimeout(function() {
                        this.scroller.scrollToPosition(0);
                    }.bind(this), 1);
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    $('#optionDropdown').removeClass('optionDropdownOnboarding');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.endFavoriteList();
                }
            );
        });
        return obs;
    }

    endFavoriteList() {
        this.extChange.emit('favoris_list_end');
        // If it's not already done
        if (this.authenticationService.currentUser.user_onboarding.favoris_list.status != 'done') {
            // Always end, even if it's not finsh
            this.authenticationService.currentUser.user_onboarding.favoris_list.status = 'done';
            this.authenticationService.currentUser.user_onboarding.favoris_list.date_end = new Date().toISOString();
            this.userService.updateOnboarding(this.authenticationService.currentUser);
            this.showEnd('favorite');
        }
    }

    // Mes preferences
    startParams(): Observable<any> {
        if (!this.isOnboardingActivate()) {
            return new Observable((subscriber) => {
                subscriber.complete();
            });
        }

        var current_step = 0;
        var steps = ['introStep@/app/user/settings', 'userDropdownStep', 'userDefaultStep', 'userFinanceStep', 'userFiscaStep', 'userAmmortStep'];

        var obs = new Observable((subscriber) => {
            this.joyrideService.startTour(
                {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
            ).subscribe(
                (step) => {
                    current_step = step.number;
                    if (this.authenticationService.currentUser.user_onboarding.parameters.status != 'done' && this.authenticationService.currentUser.user_onboarding.parameters.status != 'in_progress') {
                        this.authenticationService.currentUser.user_onboarding.parameters.status = 'in_progress';
                        this.authenticationService.currentUser.user_onboarding.parameters.date_start = new Date().toISOString();
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }

                    setTimeout(function() {
                        this.scroller.scrollToPosition(0);
                    }.bind(this), 1);
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                    $('#optionDropdown').removeClass('optionDropdownOnboarding');
                    /*Tour is finished here, do something*/
                    subscriber.next();
                    subscriber.complete();
                    this.extChange.emit('favoris_list_end');
                    // If it's not already done
                    if (this.authenticationService.currentUser.user_onboarding.parameters.status != 'done') {
                        if (current_step == steps.length) {
                            this.authenticationService.currentUser.user_onboarding.parameters.status = 'done';
                            this.authenticationService.currentUser.user_onboarding.parameters.date_end = new Date().toISOString();
                        } else {
                            this.authenticationService.currentUser.user_onboarding.parameters.status = 'in_progress';
                            this.authenticationService.currentUser.user_onboarding.parameters.date_start = new Date().toISOString();
                        }
                        this.userService.updateOnboarding(this.authenticationService.currentUser);
                    }
                    this.showEnd();
                }
            );
        });
        return obs;
    }

    showCompteMenu() {
        this.joyrideService.startTour(
            {steps: ['menuCompteStep'], showCounter: false, stepDefaultPosition: 'left', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    showSearchSaveList() {
        if (!this.isOnboardingActivate()) {
            return;
        }

        this.authenticationService.currentUser.user_onboarding.show_list_search = true;
        this.userService.updateOnboarding(this.authenticationService.currentUser);

        this.joyrideService.startTour(
            {steps: ['searchSaveListStep'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
                setTimeout(function() {
                    this.scroller.scrollToPosition(0);
                }.bind(this), 1);
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
                this.showEnd('save_search');
            }
        );
    }

    showEnd(step = '') {
        if (!this.deviceService.isDesktop() || !this.authenticationService.isLogin) {
            return;
        }

        if ((step == 'annonce' || step == 'search') &&
            this.authenticationService.currentUser.user_onboarding.annonce.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.search.status == 'done') {
            this.joyrideService.startTour(
                {steps: ['endStep1'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Fermer'}} // Your steps order
            ).subscribe(
                (step) => {
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                }
            );
            return;
        }

        if ((step == 'save_search' || step == 'favorite') &&
            this.authenticationService.currentUser.user_onboarding.annonce.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.search.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.show_list_search == true &&
            this.authenticationService.currentUser.user_onboarding.favoris_list.status == 'done') {
            this.joyrideService.startTour(
                {steps: ['endStep2'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Fermer'}} // Your steps order
            ).subscribe(
                (step) => {
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                }
            );
            return;
        }

        if ((step == 'ville') &&
            this.authenticationService.currentUser.user_onboarding.annonce.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.search.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.show_list_search == true &&
            this.authenticationService.currentUser.user_onboarding.favoris_list.status == 'done' &&
            this.authenticationService.currentUser.user_onboarding.ville.status == 'done') {
            this.joyrideService.startTour(
                {steps: ['endStep3'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Fermer'}} // Your steps order
            ).subscribe(
                (step) => {
                },
                (error) => {
                    /*handle error*/
                    console.log(error);
                },
                () => {
                }
            );
            return;
        }


        if (!this.isOnboardingActivate()) {
            return;
        }
        if (
            this.authenticationService.currentUser.user_onboarding.finish == true ||
            this.authenticationService.currentUser.user_onboarding.parameters.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.favoris_list.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.alert.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.compare.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.pdf.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.search_save.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.ville.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.annonce.status != 'done' ||
            this.authenticationService.currentUser.user_onboarding.search.status != 'done') {
            return;
        }

        this.authenticationService.currentUser.user_onboarding.finish = true;
        this.authenticationService.currentUser.user_onboarding.open = false;
        this.userService.updateOnboarding(this.authenticationService.currentUser);

        this.joyrideService.startTour(
            {steps: ['endStep'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    showSearchCitySaveList() {
        if (!this.isOnboardingActivate()) {
            return;
        }

        this.authenticationService.currentUser.user_onboarding.show_save_search_city_search = true;
        this.userService.updateOnboarding(this.authenticationService.currentUser);

        this.joyrideService.startTour(
            {steps: ['filtersCitySaveListStep'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
                setTimeout(function() {
                    this.scroller.scrollToPosition(0);
                }.bind(this), 1);
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    showHistoricMenu() {
        if (!this.isOnboardingActivate()) {
            return;
        }

        this.authenticationService.currentUser.user_onboarding.show_historic = true;
        this.userService.updateOnboarding(this.authenticationService.currentUser);

        this.joyrideService.startTour(
            {steps: ['showHistoricStep'], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    showSaveCitySearchMenu() {
        if (!this.isOnboardingActivate()) {
            return;
        }

        this.authenticationService.currentUser.user_onboarding.show_save_city_search = true;
        this.userService.updateOnboarding(this.authenticationService.currentUser);

        this.joyrideService.startTour(
            {steps: ['searchCityListStep'], showCounter: false, stepDefaultPosition: 'bottom', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    showAlert(step) {
        if (!this.isOnboardingActivate()) {
            return;
        }

        this.joyrideService.startTour(
            {steps: [step], showCounter: false, stepDefaultPosition: 'right', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }

    // Mes preferences
    startNews() {
        var current_step = 0;
        var steps = ['userDropdownStep@/app/user/settings', 'userDefaultStep', 'userFinanceStep', 'userFiscaStep', 'userAmmortStep'];

        this.joyrideService.startTour(
            {steps: steps, showCounter: false, stepDefaultPosition: 'top', waitingTime: 150, customTexts: {prev: 'Précédent', next: 'Suivant ➡', done: 'Terminé ✔'}} // Your steps order
        ).subscribe(
            (step) => {
                current_step = step.number;
                if (this.authenticationService.currentUser.user_onboarding.parameters.status != 'done' && this.authenticationService.currentUser.user_onboarding.parameters.status != 'in_progress') {
                    this.authenticationService.currentUser.user_onboarding.parameters.status = 'in_progress';
                    this.authenticationService.currentUser.user_onboarding.parameters.date_start = new Date().toISOString();
                    this.userService.updateOnboarding(this.authenticationService.currentUser);
                }

                setTimeout(function() {
                    this.scroller.scrollToPosition(0);
                }.bind(this), 1);
            },
            (error) => {
                /*handle error*/
                console.log(error);
            },
            () => {
            }
        );
    }
}

